module.exports = __webpack_public_path__ + "img/bg04.b1929061.gif";